angular
.module('monitoringSidebar.components', [])
.component('monitoringSidebar', {
	templateUrl: 'ng/components/monitoringSidebar/monitoringSidebar.html',
	bindings: {
		sidebarTitle: '@',
		sidebarIcons: '<'
	},
	controllerAs: 'monitoringSidebarCtrl',
	controller: function($rootScope) {

		//Not to loose the *this reference
		var self = this;	
		
		/**
		 * Init bindings here
		 */
        self.$onInit = function () {
        	console.log('self', self);
        }        
	}
});